import { createStorage } from './utils'
export * from './beeson'
export { TypeManager } from './type-specification'
export { Type } from './types'
export const Utils = {
  createStorage,
}
